(function ($) {
  document.ontouchmove = function (e) {
    //e.preventDefault();
    // alert(e);
    // cosole.log(e);
    return true;
  };

  var tableSelector = '.ns-table-wrap table';
  var tableWrapperSelector = '.ns-table-wrap';
  var breakPointLg = 1025;
  var breakPointMd = 768;
  var breakPointSm = 480;
  var colCountNoSplit = 3;
  var colCountEarlyBreak = 7;
  var noSplit = [];

  var tables = $(tableSelector);

  $(document).on( 'ready', function(){
    $(tableSelector).each(function () {
      var colCount = $(this).find('tbody tr:nth-of-type(3) td').length;

      if (colCount <= colCountNoSplit) {
        $(this).parents(tableWrapperSelector).addClass('nosplit');
      }

      if (colCount >= colCountEarlyBreak) {
        $(this).parents(tableWrapperSelector).addClass('js-table-early-break');
      }

      $(this).parents(tableWrapperSelector).addClass('js-table-no-spaces');
    });

    $(tableSelector).each(function () {
      $(this).parent().addClass('ns-table');
    });

    $(window).on('resize', function(){});
  });

  $(window).on('resize', function () {
    //console.log(tableWrapperSelector);
    //console.log($(this));
    if ($(window).width() < breakPointLg && $(window).width() >= breakPointMd) {

      $('.js-table-early-break').each(function () {
        var hasClone = $(this).find('.clone').length;

        if (!hasClone) {
          createClone($(this).find('table'));
        }
      });
    } else if ($(window).width() < breakPointMd) {
      $(tableWrapperSelector + ':not(.nosplit)').each(function () {
        var hasClone = $(this).find('.clone').length;

        if (!hasClone) {
          createClone($(this).find('table'));
        }
      });
    } else {
      $(tableWrapperSelector + ':not(.nosplit)').each(function () {
        var hasClone = $(this).find('.clone').length;
        if (!hasClone) {
          $(this).find('.clone').remove();
          $(this).removeClass('js-responsive-table');
        }
      });
    }
  });

  function createClone(table) {
    table.each(function () {
      // store wrapper

      // fix first row
      $(this).find('tr td:first-of-type').each(function(){

        $(this).addClass('fixed');

        // if there is a rowspan in the first element, make sure to remove all the fixed classes from the first elements that are not in the first row
        if($(this).attr('rowspan') >=2){
          var numRowSpan = parseInt($(this).attr('rowspan'));
          var currentRow = $(this).parent().index();

          for(var i = 0; i <= numRowSpan; i++){
            var table = $(this).parent().parent();
            table.find('tr:nth-of-type('+ (currentRow + i) +') td:first-of-type:not([rowspan='+numRowSpan+'])').addClass('unfixed');
          }
        }

        //it's needed to combine both classes because the classes are not properly removed on the right time
        if($(this).hasClass('fixed') && $(this).hasClass('unfixed')){
          $(this).removeClass('fixed');
        }

      });

      var wrapper = $(this).parents(tableWrapperSelector);

      wrapper.addClass('js-responsive-table');

      // remove all colspan and rowspans as well as styles and colgroups from the table
      // thius ensures no styling overrides the setup in css and proper scrolling happens.

      $(this).find('style').remove();
      $(this).find('colgroup').remove();

      // if there is a footnote, put it in the wrapper (footnote should not scroll with table)
      //console.log($(this));
      //console.log('test');
      if ($(this).siblings('div').children('.ns-style-footnote').length) {
        $(this).siblings('div').appendTo(wrapper);
      }

      // clone the table and append it to wrapper with class clone
      $(this).clone(true).appendTo(wrapper).addClass('clone');


      $(document).trigger('tablesDone');
    });
  }

  $(document).on('tablesDone', function(){
    //console.log('tables done');
  });

  $(document).on('noteLoaded', function(){
    $('.ns-table-wrap table').each(function(){
      var colCount = $(this).find('tbody tr:first td').length;
      if (colCount >= colCountEarlyBreak) {
        $(this).parents(tableWrap).addClass('js-table-early-break');
      }
    });
    $(window).on('resize', function(){});
  });
})
(jQuery);
